import React, { useRef } from 'react';
import { Tag } from '../../../../../../../common/tags/tagTypes';
import { useSelector } from 'react-redux';
import { getColorDefaultHexValue } from '../../../../../../../common/colors/elementColorFormatUtil';
import CustomColorInput from '../../colorTools/CustomColorInput';
import ColorPopupContent from '../../colorTools/popup/ColorPopupContent';
import { COLOR_POPUP_MODE } from '../../colorTools/popup/colorPopupConstants';
import { COLORS } from '../../../../../../../common/colors/colorConstants';
import currentBoardSuggestedColorSelectorOnlyColors from '../../colorTools/currentBoardSuggestedColorsSelector';

type TagColorPickerProps = {
    tag: Tag;
    closePopup: () => void;
    updateTag: (changes: Partial<Tag>) => void;
};

const TagColorPicker: React.FC<TagColorPickerProps> = ({ tag, closePopup, updateTag }) => {
    const customColorInputRef = useRef<CustomColorInput>(null);
    const suggestedColors = useSelector(currentBoardSuggestedColorSelectorOnlyColors);

    const setColor = (color: string | null) => {
        if (!color) return;

        const colorToSave = getColorDefaultHexValue(color);

        updateTag({ color: colorToSave });
        closePopup();
    };

    const openCustomColorPicker = () => {
        if (!customColorInputRef?.current) return;

        customColorInputRef.current.open();
    };

    return (
        <>
            <CustomColorInput
                className="absolute opacity-0 pointer-events-none"
                ref={customColorInputRef}
                initialColor={tag.color}
                setColor={setColor}
            />
            <ColorPopupContent
                supportBackgroundColor={false}
                supportColorBar={false}
                supportDualColors={false}
                setColor={setColor}
                selectedColor={tag.color}
                colorPopupMode={COLOR_POPUP_MODE.COLOR}
                defaultColors={Object.values(COLORS)}
                suggestedColors={suggestedColors}
                openCustomColorPicker={openCustomColorPicker}
            />
        </>
    );
};

export default TagColorPicker;
